module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTabBar && !_vm.isApp),
      expression: "showTabBar && !isApp"
    }],
    staticStyle: {
      "z-index": "12"
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tabbar-item', [(_vm.active == 0) ? _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-red1@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-grey1@2x.png"),
      "alt": ""
    }
  }), _vm._v("\n    首页\n  ")]), _vm._v(" "), _c('van-tabbar-item', [(_vm.active == 1) ? _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-red2@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-grey2@2x.png"),
      "alt": ""
    }
  }), _vm._v("\n    课程\n  ")]), _vm._v(" "), _c('van-tabbar-item', [(_vm.active == 2) ? _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-red3@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-grey3@2x.png"),
      "alt": ""
    }
  }), _vm._v("\n    文化纪\n  ")]), _vm._v(" "), _c('van-tabbar-item', [(_vm.active == 3) ? _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-red5@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "nav-img",
    attrs: {
      "src": require("../assets/images/nav/icon-homepage-grey5@2x.png"),
      "alt": ""
    }
  }), _vm._v("\n    我的\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e122f3b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBar.vue
// module id = 2614
// module chunks = 0